module.exports = __webpack_public_path__ + "static/img/rules.df1b9b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rules.png
// module id = OHHN
// module chunks = 1